import { NextSlideAction } from "../../shared/schema/AgentActionSchemas";
import { Streaming } from "../../shared/types/Streaming";
import { AgentActionUtil, registerActionUtil } from "./AgentActionUtil";

export const NextSlideActionUtil = registerActionUtil(
  class NextSlideActionUtil extends AgentActionUtil<NextSlideAction> {
    static override type = "next_slide" as const;

    override getInfo() {
      return {
        icon: "chevron-right" as const,
        description: "Moving to next slide",
      };
    }

    override savesToHistory(): boolean {
      return false;
    }

    override applyAction(action: Streaming<NextSlideAction>) {
      window.dispatchEvent(
        new CustomEvent("notepad-bite:next-slide", {
          detail: {
            timestamp: (action as Record<string, unknown>).timestamp,
          },
        }),
      );
    }
  },
);
